module.exports = __webpack_public_path__ + "img/Step2.00b4996.svg";